import { render, staticRenderFns } from "./LiveItem.vue?vue&type=template&id=3e9f2788&scoped=true"
import script from "./LiveItem.vue?vue&type=script&lang=js"
export * from "./LiveItem.vue?vue&type=script&lang=js"
import style0 from "./LiveItem.vue?vue&type=style&index=0&id=3e9f2788&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9f2788",
  null
  
)

export default component.exports